const sellsAmountRanges = [
  {
    rows: [
      {
        title: 'No tiene',
        id: 'SAR00',
        index: 0,
        color: '#9dea36',
        colorFilterValues: {
          invert: '84',
          sepia: '51',
          saturate: '671',
          hueRotate: '29',
          brightness: '102',
          contrast: '84'
        }
      },
      {
        title: '0-100000',
        id: 'SAR016',
        index: 0,
        color: '#9dea36',
        colorFilterValues: {
          invert: '84',
          sepia: '51',
          saturate: '671',
          hueRotate: '29',
          brightness: '102',
          contrast: '84'
        }
      },
      {
        title: '100000-250000',
        id: 'SAR018',
        index: 1,
        color: '#9dea36',
        colorFilterValues: {
          invert: '84',
          sepia: '51',
          saturate: '671',
          hueRotate: '29',
          brightness: '102',
          contrast: '84'
        }
      },
      {
        title: '250000-500000',
        id: 'SAR017',
        index: 2,
        color: '#9dea36',
        colorFilterValues: {
          invert: '84',
          sepia: '51',
          saturate: '671',
          hueRotate: '29',
          brightness: '102',
          contrast: '84'
        }
      },
      {
        title: '500000-1000000',
        id: 'SAR01',
        index: 3,
        color: '#9dea36',
        colorFilterValues: {
          invert: '84',
          sepia: '51',
          saturate: '671',
          hueRotate: '29',
          brightness: '102',
          contrast: '84'
        }
      },
      {
        title: '1000000-2000000',
        id: 'SAR14',
        index: 4,
        color: '#9dea36',
        colorFilterValues: {
          invert: '84',
          sepia: '51',
          saturate: '671',
          hueRotate: '29',
          brightness: '102',
          contrast: '84'
        }
      },
      {
        title: '2000000-3000000',
        id: 'SAR15',
        index: 5,
        color: '#9dea36',
        colorFilterValues: {
          invert: '84',
          sepia: '51',
          saturate: '671',
          hueRotate: '29',
          brightness: '102',
          contrast: '84'
        }
      },
      {
        title: '3000000-6000000',
        id: 'SAR02',
        index: 6,
        color: '#9dea36',
        colorFilterValues: {
          invert: '84',
          sepia: '51',
          saturate: '671',
          hueRotate: '29',
          brightness: '102',
          contrast: '84'
        }
      },
      {
        title: '6000000-12000000',
        id: 'SAR03',
        index: 7,
        color: '#9dea36',
        colorFilterValues: {
          invert: '84',
          sepia: '51',
          saturate: '671',
          hueRotate: '29',
          brightness: '102',
          contrast: '84'
        }
      },
      {
        title: '12000000-30000000',
        id: 'SAR04',
        index: 8,
        color: '#9dea36',
        colorFilterValues: {
          invert: '84',
          sepia: '51',
          saturate: '671',
          hueRotate: '29',
          brightness: '102',
          contrast: '84'
        }
      },
      {
        title: '30000000-60000000',
        id: 'SAR05',
        index: 9,
        color: '#9dea36',
        colorFilterValues: {
          invert: '84',
          sepia: '51',
          saturate: '671',
          hueRotate: '29',
          brightness: '102',
          contrast: '84'
        }
      }
    ]
  },
  {
    rows: [
      {
        title: '60000000-120000000',
        id: 'SAR06',
        index: 10,
        color: '#9dea36',
        colorFilterValues: {
          invert: '84',
          sepia: '51',
          saturate: '671',
          hueRotate: '29',
          brightness: '102',
          contrast: '84'
        }
      },
      {
        title: '120000000-250000000',
        id: 'SAR07',
        index: 11,
        color: '#9dea36',
        colorFilterValues: {
          invert: '84',
          sepia: '51',
          saturate: '671',
          hueRotate: '29',
          brightness: '102',
          contrast: '84'
        }
      },
      {
        title: '250000000-500000000',
        id: 'SAR08',
        index: 12,
        color: '#9dea36',
        colorFilterValues: {
          invert: '84',
          sepia: '51',
          saturate: '671',
          hueRotate: '29',
          brightness: '102',
          contrast: '84'
        }
      },
      {
        title: '500000000-1000000000',
        id: 'SAR09',
        index: 13,
        color: '#9dea36',
        colorFilterValues: {
          invert: '84',
          sepia: '51',
          saturate: '671',
          hueRotate: '29',
          brightness: '102',
          contrast: '84'
        }
      },
      {
        title: '1000000000-2000000000',
        id: 'SAR10',
        index: 14,
        color: '#9dea36',
        colorFilterValues: {
          invert: '84',
          sepia: '51',
          saturate: '671',
          hueRotate: '29',
          brightness: '102',
          contrast: '84'
        }
      },
      {
        title: '2000000000-5000000000',
        id: 'SAR11',
        index: 15,
        color: '#9dea36',
        colorFilterValues: {
          invert: '84',
          sepia: '51',
          saturate: '671',
          hueRotate: '29',
          brightness: '102',
          contrast: '84'
        }
      },
      {
        title: '5000000000-10000000000',
        id: 'SAR12',
        index: 16,
        color: '#9dea36',
        colorFilterValues: {
          invert: '84',
          sepia: '51',
          saturate: '671',
          hueRotate: '29',
          brightness: '102',
          contrast: '84'
        }
      },
      {
        title: '10000000000-o más',
        id: 'SAR13',
        index: 17,
        color: '#9dea36',
        colorFilterValues: {
          invert: '84',
          sepia: '51',
          saturate: '671',
          hueRotate: '29',
          brightness: '102',
          contrast: '84'
        }
      }
    ]
  }
]

export default sellsAmountRanges
